export const LOCALES = {
    EN: 'en-US',
    UA: 'uk-UA',
    RU: 'ru-RU',
};

export const SUPPORTED_LOCALES = [LOCALES.EN, LOCALES.UA, LOCALES.RU] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<string, string> = {
    [LOCALES.EN]: 'EN',
    [LOCALES.UA]: 'UA',
    [LOCALES.RU]: 'RU',
};

const dayjsLocaleMap: Record<string, string> = {
    [LOCALES.EN]: 'en',
    [LOCALES.UA]: 'uk',
    [LOCALES.RU]: 'ru',
};

export const toDayjsLocale = (locale: string): string =>
    dayjsLocaleMap[locale] ?? 'en';
